import React from "react";
import MovieListItem from "../movieListItem/movieListItem";
import "./movieList.scss";

const MovieList = ({ movies }) => {
  return (
    <div className="movie-list">
      {movies.map(item => {
        return <MovieListItem key={item.id} {...item} />;
      })}
    </div>
  );
};

export default MovieList;
